import { Component, OnInit, ViewChild, Renderer } from '@angular/core';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { LoyaltyService } from '../../../../../../shared/_services/loyalty.service';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { ValidationService } from '../../../../../../shared/_services/validation.service';
import { UtilService } from '../../../../../../shared/_services/util.service';
import { HcaBrandService } from '../../../../../../shared/_services/hca-brand.service';
import { MarketingService } from '../../../../../../shared/_services/marketing.service';
import { Observable } from 'rxjs/Observable';
import { HttpService } from '../../../../../../shared/_services/http.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Subject } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HcaUserManagementService } from '../../../../../../shared/_services/hca-user-management.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hotel-brand-wizard',
  templateUrl: './hotel-brand-wizard.component.html',
  styleUrls: ['./hotel-brand-wizard.component.scss']
})

export class HotelBrandWizardComponent implements OnInit {
  adminTerm$: any;
  brandTerm$: any;
  hotels: any[];
  hcaRoles: any;
  loyaltyAdmin: FormGroup;
  imageUrl: SafeResourceUrl;
  tagInputText: string;
  dateRepeated: boolean = false;
  isDatesRepeated: boolean = false;
  languages: any;
  selectedBrandIndex: any = 0;
  selectedBrand: any;
  loyaltyBrand: FormGroup;
  currencies: any;
  travelAgentMemberType: FormGroup;
  employeeMemberProgramType: FormGroup;
  consumerMemberProgramType: FormGroup;
  loyalty2Form: FormGroup;
  travelAgentType: FormGroup;
  employeeProgramType: FormGroup;
  consumerProgramType: FormGroup;
  selectedProgramTypes: any[];
  formData: any;
  bookingTypes: any;
  programTypes: any;
  errorDetails: string = "";
  loyalty: any = FormGroup;
  errorUpload: boolean;
  imageFile: any;
  hotel: any = FormGroup;
  items = [];
  searchTerm$ = new Subject<string>();
  bsConfig: Partial<BsDatepickerConfig> = { containerClass: 'theme-orange' };
  hotelTags: (text: string) => Observable<Response>;
  statusModal: BsModalRef;
  @ViewChild('uploadLogoFile') uploadLogoFile: any;
  @ViewChild('uploadFavFile') uploadFavFile: any;
  @ViewChild('uploadBannerFile') uploadBannerFile: any;
  @ViewChild('consumerProgram') consumerProgramEle: any;
  @ViewChild('employeeProgram') employeeProgramEle: any;
  @ViewChild('travelAgent') travelAgentEle: any;
  @ViewChild('consumerContentProgram') consumerContentProgramEle: any;
  @ViewChild('employeeContentProgram') employeeContentProgramEle: any;
  @ViewChild('travelContentAgent') travelContentAgentEle: any;
  
  @ViewChild('consumerMemberProgram') consumerMemberProgramEle: any;
  @ViewChild('employeeMemberProgram') employeeMemberProgramEle: any;
  @ViewChild('travelAgentMember') travelAgentMemberEle: any;
  @ViewChild('consumerMemberContentProgram') consumerMemberContentProgramEle: any;
  @ViewChild('employeeMemberContentProgram') employeeMemberContentProgramEle: any;
  @ViewChild('travelAgentContentMember') travelAgentContentMemberEle: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private fb: FormBuilder,
    private http: HttpService,
    private sanitizer: DomSanitizer,
    public modalService: BsModalService,
    private validationService: ValidationService,
    private hcaUserManagementService: HcaUserManagementService,
    private marketingService: MarketingService,
    private utilService: UtilService,
    private loyaltyService: LoyaltyService,
    private hcaBrandService: HcaBrandService,
    private router: Router,
    private renderer: Renderer
  ) {
    this.hotelTags = (text: string): Observable<Response> => {
      const url = `/hotel/getHotelTags/hotel/${text}`;
      return this.http
        .get(url).debounceTime(300)
        .distinctUntilChanged()
        .map(data => {
          if (data.json().error == 0) {
            if (data.json().responseObj.length) {
              return data.json().responseObj
            } else {
              this.tagInputText = "";
            }
          }
        });
    }

    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.type == "hca-wizard") {
            if (this.statusModal.content.srcObject.action == "action1") {
              this.router.navigate(['/hotel-management']);
            }
          }
          if (this.statusModal.content.srcObject.type == "hca-remove") {
            if (this.statusModal.content.srcObject.action == "action1") {
              const form = this.statusModal.content.srcObject.form;
              const control = this.statusModal.content.srcObject.control;
              const i = this.statusModal.content.srcObject.i;
              const type = this.statusModal.content.srcObject.type2;
              this.removeControl(form, control, i, type);
            }
          }
          if (this.statusModal.content.srcObject.type == "hca-image") {
            if (this.statusModal.content.srcObject.action == "action1") {
              // this.loyaltyBrand.get("brandsList").get(this.selectedBrandIndex).get("logoUrl").patchValue(null);
              const form = this.statusModal.content.srcObject.form;
              const control = this.statusModal.content.srcObject.control;
              const i = this.statusModal.content.srcObject.i;
              const type = this.statusModal.content.srcObject.type2;
              const imageType = this.statusModal.content.srcObject.imageType;
              this.removeImage(form, control, i, type, imageType);
            }
          }
        }
      })
  }

  fileChanged(event: any, type?, ctrl?, brandIdx?, hotelIdx?) {
    
        const brandCtrl = <FormArray>this.loyaltyBrand.controls['brandsList'];
        const brandIdxCtrl = brandCtrl.at(brandIdx);
        const hotelCtrl = <FormArray>brandCtrl.at(brandIdx).get('hotelsList');
        const hotelIdxCtrl = hotelCtrl.at(hotelIdx);
    
        let image = URL.createObjectURL(event.target.files[0]);
    
        let fileList: FileList = event.target.files;
        this.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(image);
        this.imageFile = event.target.files[0];
        if (ctrl == 'brand') {
          if (type == 'logo') {
            brandIdxCtrl.get('logoError').patchValue(false);
            this.removeImage(brandIdxCtrl, brandIdx, brandIdx, ctrl, type);
          } else if (type == 'favicon') {
            brandIdxCtrl.get('favError').patchValue(false);
            this.removeImage(brandIdxCtrl, brandIdx, brandIdx, ctrl, type);
          }
        } else {
          hotelIdxCtrl.get('bannerError').patchValue(false);
          this.removeImage(hotelIdxCtrl, hotelIdx, brandIdx, ctrl, type);
        }
        this.errorUpload = false;
        if (fileList.length > 0 && (this.imageFile.type === 'image/png' || this.imageFile.type === 'image/jpg' || this.imageFile.type === 'image/jpeg')) {
          if (ctrl == 'brand') {
            if (type == 'logo') {
              brandIdxCtrl.get('logoError').patchValue(false);
            } else if (type == 'favicon') {
              brandIdxCtrl.get('favError').patchValue(false);
            }
          } else {
            hotelIdxCtrl.get('bannerError').patchValue(false);
          }
          this.errorUpload = false;
        } else {
          if (ctrl == 'brand') {
            if (type == 'logo') {
              brandIdxCtrl.get('logoError').patchValue(true);
              this.resetFileInput('uploadLogoFile');
            } else if (type == 'favicon') {
              brandIdxCtrl.get('favError').patchValue(true);
              this.resetFileInput('uploadFavFile');
            }
          } else {
            hotelIdxCtrl.get('bannerError').patchValue(true);
            this.resetFileInput('uploadBannerFile');
          }
          this.errorUpload = true;
        }
        let formData: any = new FormData();
        if (this.imageFile) {
          let fileName = this.imageFile.name ? `${this.utilService.getRandomInt(0, 1000000)}_${this.imageFile.name}` : this.utilService.getRandomInt(0, 1000000);
          formData.append('image', this.imageFile, fileName);
        } else {
          var file = new Blob([], { type: 'image/jpg' });
          formData.append('image', file, null);
        }
        this.utilService.uploadFile(formData).subscribe((res) => {
          if (res.error == 0) {
            if (ctrl == 'brand') {
              if (type == 'logo') {
                brandIdxCtrl.get('brandLogoName').patchValue(this.imageFile.name);
                brandIdxCtrl.get('brandLogo').patchValue(res.responseObj);
                brandIdxCtrl.get('logoUrl').patchValue(this.imageUrl);
                this.resetFileInput('uploadLogoFile');
              } else if (type == 'favicon') {
                brandIdxCtrl.get('faviconName').patchValue(this.imageFile.name);
                brandIdxCtrl.get('favicon').patchValue(res.responseObj);
                brandIdxCtrl.get('favUrl').patchValue(this.imageUrl);
                this.resetFileInput('uploadFavFile');
              }
            } else {
              hotelIdxCtrl.get('bannerName').patchValue(this.imageFile.name);
              hotelIdxCtrl.get('banner').patchValue(res.responseObj);
              hotelIdxCtrl.get('bannerUrl').patchValue(this.imageUrl);
              this.resetFileInput('uploadBannerFile');
            }
          } else {
            if (ctrl == 'brand') {
              if (type == 'logo') {
                this.resetFileInput('uploadLogoFile');
              } else if (type == 'favicon') {
                this.resetFileInput('uploadFavFile');
              }
            } else {
              this.resetFileInput('uploadBannerFile');
            }
            this.errorDetails = "Error while Uploading image";
          }
        }, error => {
          this.errorDetails = error.message;
          if (ctrl == 'brand') {
            if (type == 'logo') {
              this.resetFileInput('uploadLogoFile');
            } else if (type == 'favicon') {
              this.resetFileInput('uploadFavFile');
            }
          } else {
            this.resetFileInput('uploadBannerFile');
          }
          console.log('========res ===========', error);
        })
    
      }

  goBack() {
    window.history.back();
  }

  cancel() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-wizard',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to cancel out of configuring hotel chain details?',
      action1: 'Yes',
      action2: 'No',
      action: '',
      style: 'active'
    }
  }
  remove(form, control, i, type2?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-remove',
      title: 'Confirm',
      status: 'Active',
      message: `Are you sure you want to remove ${type2}?`,
      action1: 'Remove',
      action2: 'Cancel',
      action: '',
      style: 'inactive',
      form: form,
      control: control,
      i: i,
      type2: type2
    }
  }
  deleteImage(form, control, i, type2, imageType) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-image',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to delete this image?',
      action1: 'Yes',
      action2: 'No',
      action: '',
      form: form,
      control: control,
      i: i,
      type2: type2,
      imageType: imageType

    }
  }

  saveWizard(from?, to?) {
    this.formData = {
      brandsList: [],
      adminsList: []
    }

    if (from == 'saveLoyalty') {
      this.formData.brandsList = this.loyaltyBrand.value.brandsList;
      this.formData.adminsList = this.loyaltyAdmin.value.adminsList;


      this.loyaltyService.createBrandWizard(this.formData).subscribe(res => {
        this.router.navigate(['/hotel-management']);
      }, err => {
        console.error('================res============', err);
      })
    }
  }

  getProgramTypes() {
    this.loyaltyService.getProgramTypes().subscribe(res => {
      if (res.error == 0) {
        this.programTypes = res.responseObj;
      }
    })
  }

  getBookingTypes() {
    this.loyaltyService.getBookingTypes().subscribe(res => {
      if (res.error == 0) {
        this.bookingTypes = res.responseObj;
      }
    })
  }

  getCurrencyTypes() {
    this.marketingService.getCurrencyTypes()
      .subscribe(
      res => {
        if (res.error == 0) {
          this.currencies = res.responseObj;
        }
        else {
          console.error("get currency :" + res.message);
        }
      },
      err => {
        console.error(err);
      });
  }

  getLanguageCodes() {
    this.hcaBrandService.getLanguageCodes().subscribe(
      res => {
        if (res.error == 0) {
          this.languages = res.responseObj;
          if (res.responseObj.length > 0) {
          }
        }
        else {
          console.error("Get Languages : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  getRolesForHCA() {
    this.hcaUserManagementService.getRolesForHCA().subscribe(
      res => {
        if (res.error == 0) {
          this.hcaRoles = res.responseObj;
        }
        else {
          console.error("Get Admin Roles : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  selectDate(event, type, hotelIdx, seasonIdx) {
    console.log(`============= event for index ${seasonIdx} =================`, event)
  }

  initBookingTypes() {
    return this.fb.group({
      points: this.fb.group({
        costOfBooking: [null],
        costOfExtras: [null],
        coeficient: [null]
      }),
      guests: this.fb.group({
        isSeniors: [false],
        isAdults: [false],
        isYouth: [false],
        isChild: [false],
        isInfants: [false]
      })
    })
  }

  initLoyalty1Form() {
    this.loyalty = this.fb.group({
      programmeName: [null, Validators.required],
      programType: this.fb.array([], this.validationService.minLengthArray(1)),
      bookingType: this.fb.array([], this.validationService.minLengthArray(1)),
    })
  }

  removeControl(form, control, i, type?) {
    if (type == 'hotel') {
      const formControl = <FormArray>form.controls[control];
      formControl.removeAt(i);
    } else {
      const formControl = <FormArray>this[form].controls[control];
      formControl.removeAt(i);
      this.selectedBrandIndex = 0;
    }
  }


  removeImage(form, control, i, type?, imageType?) {
    if (type == 'hotel') {
      if (imageType == 'banner') {

        form.get('bannerUrl').patchValue(null, { emitEvent: false });
        form.get('bannerName').patchValue(null, { emitEvent: false });
        form.get('banner').patchValue(null, { emitEvent: false });
        form.get('bannerError').patchValue(false, { emitEvent: false });
      }
    } else if (type == 'brand') {
      if (imageType == 'logo') {
        form.get('brandLogoName').patchValue(null, { emitEvent: false });
        form.get('logoUrl').patchValue(null, { emitEvent: false });
        form.get('brandLogo').patchValue(null, { emitEvent: false });
        form.get('logoError').patchValue(false, { emitEvent: false });
      } else if (imageType == 'favicon') {
        form.get('favUrl').patchValue(null, { emitEvent: false });
        form.get('faviconName').patchValue(null, { emitEvent: false });
        form.get('favicon').patchValue(null, { emitEvent: false });
        form.get('favError').patchValue(false, { emitEvent: false });
      }
    }
  }


  getBrandDetailsByBrandId(brand, i) {
    this.selectedBrand = brand;
    this.selectedBrandIndex = i;
  }

  initSeason() {
    return this.fb.group({
      seasonId: [null],
      name: [null],
      dateTo: [null],
      dateFrom: [null],
      points: [null],
    }, this.validationService.minLengthArray(1))
  }

  addSeason(brandIdx, hotelIdx) {
    let brandListForm = this.loyaltyBrand.get('brandsList') as FormArray;
    let hotelForm = brandListForm.at(brandIdx).get('hotelsList') as FormArray;
    let seasonForm = hotelForm.at(hotelIdx).get('seasonsList') as FormArray;
    seasonForm.push(this.fb.group({
      seasonId: [null],
      name: [null],
      dateTo: [null],
      dateFrom: [null],
      points: [null],
    }))
  }

  initHotel() {
    let seasonsList: FormArray = new FormArray([]);
    return this.fb.group({
      hotelName: [null, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(60)])],
      brandId: [null],
      description: [null],
      website: [null, Validators.compose([Validators.pattern(this.validationService.webUrl_regexPattern)])],
      tags: [null],
      bannerName: [null],
      banner: [null],
      bannerUrl: [null],
      bannerError: [false],
      isDatesRepeated: [false],
      dateRepeated: [false],
      seasonsList: this.fb.array([
        this.initSeason()
      ]),
    })
  }

  addHotel(i) {
    let seasonsList: FormArray = new FormArray([]);
    let brandListForm = this.loyaltyBrand.get('brandsList') as FormArray;
    let hotelForm = brandListForm.at(i).get('hotelsList') as FormArray;
    hotelForm.push(this.fb.group({
      hotelName: [null, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(60)])],
      brandId: [null],
      description: [null],
      website: [null, Validators.compose([Validators.pattern(this.validationService.webUrl_regexPattern)])],
      tags: [null],
      bannerName: [null],
      banner: [null],
      bannerUrl: [null],
      bannerError: [false],
      isDatesRepeated: [false],
      dateRepeated: [false],
      seasonsList: this.fb.array([
        this.initSeason()
      ]),
    }))
  }

  addLoyaltyBrand() {
    let hotelsList: FormArray = new FormArray([]);
    let brandListForm = this.loyaltyBrand.get('brandsList') as FormArray;
    brandListForm.push(this.fb.group({
      brandId: [null],
      brandName: new FormControl(null, [Validators.required], [this.validationService.checkUserName]),
      brandNameError: [false],
      website: [null, Validators.compose([Validators.pattern(this.validationService.webUrl_regexPattern)])],
      languageId: ["", Validators.required],
      brandLogoName: [null],
      brandLogo: [null],
      logoUrl: [null],
      logoError: [false],
      faviconName: [null],
      favicon: [null],
      favUrl: [null],
      favError: [false],
      hotelChainId: [JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId],
      hotelsList: this.fb.array([
        // this.initHotel()
      ])
    }, this.validationService.minLengthArray(1)))
  }

  getHotelBrandsByHotelChain(brandName) {
    this.loyaltyBrand.controls['brandsList'].value.forEach(brand => {
      if (brand.brandName == brandName) {
        this.hotels = brand.hotelsList;
      }
    })
  }

  selectedRole(adminIdx) {
    let adminForm = <FormArray>this.loyaltyAdmin.get('adminsList');
    let adminIdxCtrl = adminForm.at(adminIdx);
    let brandIdControl = <FormArray>adminIdxCtrl.get('brandName');
    let role = adminIdxCtrl.get('roleId').value;
    let hotel = adminIdxCtrl.get('hotelName');
    let brand = adminIdxCtrl.get('brandName');
    this.hotels = [];
    hotel.enable();
    brand.enable();
    adminIdxCtrl.get('isAllBrandsSelected').patchValue(false, { emitEvent: false });
    adminIdxCtrl.get('isAllHotelsSelected').patchValue(false, { emitEvent: false });
    hotel.setValue("", { emitEvent: false });
    brand.setValue("", { emitEvent: false });
    if (role == '' || role == null) {
      brand.disable();
      hotel.disable();
      this.hotels = [];
      adminIdxCtrl.get('isAllBrandsSelected').patchValue(true, { emitEvent: false });
      adminIdxCtrl.get('isAllHotelsSelected').patchValue(true, { emitEvent: false });
      hotel.setValue("", { emitEvent: false });
      brand.setValue("", { emitEvent: false });
    }
    if (role != 12) {
      this.getHotelBrandsByHotelChain(brand.value);
      if (role == 14 && brand.value) {
        hotel.enable();
        adminIdxCtrl.get('isAllHotelsSelected').patchValue(false, { emitEvent: false });
      } else {
        hotel.disable();
        this.hotels = [];
        adminIdxCtrl.get('isAllHotelsSelected').patchValue(true, { emitEvent: false });
        hotel.setValue("", { emitEvent: false });
      }
    } else {
      brand.disable();
      hotel.disable();
      this.hotels = [];
      adminIdxCtrl.get('isAllBrandsSelected').patchValue(true, { emitEvent: false });
      adminIdxCtrl.get('isAllHotelsSelected').patchValue(true, { emitEvent: false });
      hotel.setValue("", { emitEvent: false });
      brand.setValue("", { emitEvent: false });
    }
  }

  selectedBrands(adminIdx) {
    let adminForm = <FormArray>this.loyaltyAdmin.get('adminsList');
    let adminIdxCtrl = adminForm.at(adminIdx);
    let brandIdControl = <FormArray>adminIdxCtrl.get('brandName');
    let role = adminIdxCtrl.get('roleId').value;
    let hotel = adminIdxCtrl.get('hotelName');
    let brand = adminIdxCtrl.get('brandName');
    if (role && role == 14) {
      this.getHotelBrandsByHotelChain(brand.value);
      adminIdxCtrl.get('hotelName').setValue("", { emitEvent: false });
      adminIdxCtrl.get('isAllHotelsSelected').patchValue(false, { emitEvent: false });
      hotel.enable();
    }
    else {
      hotel.disable();
      this.hotels = [];
      adminIdxCtrl.get('isAllHotelsSelected').patchValue(true, { emitEvent: false });
      hotel.setValue("", { emitEvent: false });
    }
  }


  templateString(type, info) {
    return `${info} ${type}${info == 1 ? '' : 's'} selected`;
  }


  resetFileInput(element?) {
    this[element].nativeElement.value = "";
  }

  addLoyaltyAdmin() {
    let adminForm = this.loyaltyAdmin.controls['adminsList'] as FormArray;
    adminForm.push(this.fb.group({
      roleId: ['', Validators.required],
      brandId: [''],
      brandName: ['', Validators.required],
      brandNames: this.fb.array([]),
      hotelId: [''],
      hotelName: ['', Validators.required],
      hotelNames: this.fb.array([]),
      isAllBrandsSelected: [false],
      isAllHotelsSelected: [false],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      // email: new FormControl(null, [Validators.required, Validators.pattern(this.validationService.email_regexPattern)], [this.validationService.checkEmail]),
      email: new FormControl(null, [Validators.required], [this.validationService.checkEmail]),
      // mobileNumber: ['', Validators.compose([Validators.minLength(10), Validators.maxLength(15), Validators.pattern(this.validationService.phoneNumber_regexPattern)])],
      mobileNumber: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(15)])],
      skypeId: ['']
    }, this.validationService.minLengthArray(1)))
  }

  initLoyaltyBrandForm() {
    let brandsList: FormArray = new FormArray([]);
    this.loyaltyBrand = this.fb.group({
      brandsList: brandsList
    })
    this.addLoyaltyBrand();
  }

  initLoyaltyAdminForm() {
    let adminsList: FormArray = new FormArray([]);
    this.loyaltyAdmin = this.fb.group({
      adminsList: adminsList
    })
    this.addLoyaltyAdmin();
  }

  initForm() {
    this.initLoyalty1Form();
    this.initLoyaltyBrandForm();
    this.initLoyaltyAdminForm();
  }

  get brandListArray() {
    let formArray = <FormArray>this.loyaltyBrand.controls['brandsList'];
    return formArray.at(this.selectedBrandIndex);
  }

  get hotelListControl() {
    let formArray = <FormArray>this.brandListArray.get('hotelsList');
    return formArray.controls;
  }

  ngOnInit() {
    this.initForm();
    this.getProgramTypes();
    this.getBookingTypes();
    this.getCurrencyTypes();
    this.getLanguageCodes();
    this.getRolesForHCA();
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}


// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/hotels/hotel-management/hotel-brand-wizard/hotel-brand-wizard.component.ts